<template>
  <div class="dashboard-entry w-100 h-100 d-flex justify-content-between flex-column align-items-center">
    <div class="dashboard h-100">
      <div class="orders">
        <p class="title">Aufträge</p>
        <p :class="[ordersAmountColor, 'amount']">{{ this.dashboardData.ordersAmount }}</p>
      </div>
      <div class="handled">
        <p class="title">Abgewickelt</p>
        <p :class="[handledAmountColor, 'amount']">{{ this.dashboardData.handledAmount }}</p>
      </div>
      <div class="incoming-goods">
        <p class="title">Wareneingänge</p>
        <p class="amount">{{ this.dashboardData.incomingGoodsAmount }}</p>
      </div>
      <div class="relocation-of-goods">
        <p class="title ">Umlagerungen</p>
        <p :class="[relocationOfGoodsColor, 'amount']">{{ this.dashboardData.relocationOfGoods }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import "moment-timezone/builds/moment-timezone-with-data-1970-2030";
import moment from "moment-timezone";
export default {
  name: "PLTable",
  props: [
    'dashboardData'
  ],
  data() {
    return {
      ordersAmountColor: null,
      handledAmountColor: null,
      relocationOfGoodsColor: null,
      date: null,
    };
  },

  watch: {
    dashboardData: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.getOrdersColor();
          this.getHandledColor();
          this.getRelocationColor();
        }
      },
      deep: true
    },
  },
  methods: {
    getOrdersColor() {
      const amount = this.dashboardData.ordersAmount;
      switch (true) {
        case amount > 700: this.ordersAmountColor = "red";
          break;
        case amount > 200 && amount <= 700: this.ordersAmountColor = "yellow";
          break;
        default: this.ordersAmountColor = "green";
      }
      return null;
    },
    getHandledColor() {
      const amount = this.dashboardData.handledAmount;
      switch (true) {
        case amount > 700: this.handledAmountColor = "green";
          break;
        case amount > 200 && amount <= 700: this.handledAmountColor = "yellow";
          break;
        default: this.handledAmountColor = "red";
      }
      return;
    },
    getRelocationColor() {
      const amount = this.dashboardData.relocationOfGoods;
      switch (true) {
        case amount > 9: this.relocationOfGoodsColor = "red";
          break;
        case amount >= 5 && amount <= 8: this.relocationOfGoodsColor = "yellow";
          break;
        default: this.relocationOfGoodsColor = "green";
      }
      return;
    },
  },
  mounted() {
    this.getOrdersColor();
    this.getHandledColor();
    this.getRelocationColor();
    setInterval(() => {
      this.date = moment(new Date()).locale('de').format('LL') + ', ' + moment(new Date()).locale('de').format('LTS')
    }, 1000);
  },
}
</script>

<style scoped>
.title {
  font-size: clamp(6rem, 7rem, 8rem);
  font-weight: 700;
  text-align: center;
}

.amount {
  font-size: clamp(8rem, 9rem, 10rem);
  font-weight: 700;
  text-align: center;
}

.dashboard-entry {
  width: 100%;
  height: 100%;
  padding: 2rem 2rem 2rem 2rem
}

.dashboard {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 2rem;
  grid-row-gap: 2rem;

}

.orders {
  background-color: #303030;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
}

.incoming-goods {
  background-color: #303030;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
}

.handled {
  background-color: #303030;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
}

.relocation-of-goods {
  background-color: #303030;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
}

.red {
  color: #e92e2e;
}

.yellow {
  color: rgb(241, 241, 8);
}

.green {
  color: rgb(9, 236, 9);
}

.createdDate {
  font-size: clamp(1.5rem, 2rem, 2.5rem) !important;
}
</style>